(function () {
  'use strict';

  var BENCHMARKS = {
    apparel:     { defaultOR: 38, defaultCTR: 1.6, defaultConv: 2.2, realistic: { emailPct: 25, flowShare: 40 }, best: { emailPct: 35, flowShare: 50 } },
    beauty:      { defaultOR: 42, defaultCTR: 1.8, defaultConv: 2.8, realistic: { emailPct: 28, flowShare: 45 }, best: { emailPct: 38, flowShare: 55 } },
    supplements: { defaultOR: 44, defaultCTR: 2.0, defaultConv: 3.2, realistic: { emailPct: 30, flowShare: 50 }, best: { emailPct: 42, flowShare: 60 } },
    home:        { defaultOR: 36, defaultCTR: 1.5, defaultConv: 2.0, realistic: { emailPct: 22, flowShare: 35 }, best: { emailPct: 32, flowShare: 45 } },
    food:        { defaultOR: 40, defaultCTR: 1.7, defaultConv: 2.5, realistic: { emailPct: 28, flowShare: 45 }, best: { emailPct: 38, flowShare: 55 } },
    other:       { defaultOR: 38, defaultCTR: 1.6, defaultConv: 2.2, realistic: { emailPct: 25, flowShare: 40 }, best: { emailPct: 35, flowShare: 50 } }
  };

var CURRENCY = {
  EUR: { symbol: '€' },
  USD: { symbol: '$' },
  GBP: { symbol: '£' }
};
function formatMoney(amount, currency) {
  var fmt = CURRENCY[currency] || CURRENCY.EUR;
  return fmt.symbol + Math.round(amount).toLocaleString('en-US');
}

  function getSymbol(currency) {
    return (CURRENCY[currency] || CURRENCY.EUR).symbol;
  }

  /* ─── Count-up animation ──────────────────────────── */

  var _rafId = null;
  var _displayedGap = 0;

  function animateGap(target, currency, el) {
    if (_rafId) cancelAnimationFrame(_rafId);
    var start = _displayedGap;
    var duration = 400;
    var t0 = performance.now();

    function tick(now) {
      var progress = Math.min((now - t0) / duration, 1);
      var current = Math.round(start + (target - start) * progress);
      el.textContent = formatMoney(current, currency) + '/year';
      if (progress < 1) {
        _rafId = requestAnimationFrame(tick);
      } else {
        _displayedGap = target;
      }
    }
    _rafId = requestAnimationFrame(tick);
  }

  /* ─── Slider fill ─────────────────────────────────── */

  function updateSliderFill(slider) {
    var min = parseFloat(slider.min) || 0;
    var max = parseFloat(slider.max) || 100;
    var pct = ((parseFloat(slider.value) - min) / (max - min)) * 100;
    slider.style.backgroundSize = pct.toFixed(1) + '% 100%';
    slider.setAttribute('aria-valuenow', slider.value);
  }

  /* ─── Typeform URL ────────────────────────────────── */

  function buildTypeformUrl(base, vertical, currency, p) {
    var enc = encodeURIComponent;
    var frag = [
      'vertical='                 + enc(vertical),
      'currency='                 + enc(currency),
      'monthly_revenue='          + enc(Math.round(p.monthlyStoreRevenue)),
      'list_size='                + enc(Math.round(p.listSize)),
      'active_pct='               + enc(Math.round(p.activePct)),
      'campaigns_per_month='      + enc(Math.round(p.campaignsPerMonth)),
      'open_rate='                + enc(Math.round(p.openRate)),
      'click_rate='               + enc(Math.round(p.clickRate)),
      'conv_rate='                + enc(Math.round(p.convRate)),
      'aov='                      + enc(Math.round(p.aov)),
      'flow_revenue='             + enc(Math.round(p.flowRevenue)),
      'email_pct_current='        + enc(Math.round(p.currentEmailPct)),
      'annual_gap='               + enc(Math.round(p.annualGap)),
      'realistic_annual_revenue=' + enc(Math.round(p.realisticAnnualRevenue))
    ].join('&');
    return base + '#' + frag;
  }

  /* ─── Debounce ────────────────────────────────────── */

  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  /* ─── Main init ───────────────────────────────────── */

  function init(section) {
    var config = {};
    try { config = JSON.parse(section.getAttribute('data-config') || '{}'); } catch (e) {}

    var qualThreshold  = config.qualificationThreshold || 60000;
    var typeformUrl    = config.typeformUrl    || '';
    var newsletterUrl  = config.newsletterUrl  || '#';

    /* Inputs */
    var selVertical    = section.querySelector('#sl-vertical');
    var selCurrency    = section.querySelector('#sl-currency');
    var inpRevenue     = section.querySelector('#sl-monthly-revenue');
    var inpListSize    = section.querySelector('#sl-list-size');
    var slActivePct    = section.querySelector('#sl-active-pct');
    var slCampaigns    = section.querySelector('#sl-campaigns');
    var slOpenRate     = section.querySelector('#sl-open-rate');
    var slClickRate    = section.querySelector('#sl-click-rate');
    var slConvRate     = section.querySelector('#sl-conv-rate');
    var inpAov         = section.querySelector('#sl-aov');
    var inpFlow        = section.querySelector('#sl-flow-revenue');

    /* Slider value displays */
    var valActivePct   = section.querySelector('#sl-active-pct-val');
    var valCampaigns   = section.querySelector('#sl-campaigns-val');
    var valOpenRate    = section.querySelector('#sl-open-rate-val');
    var valClickRate   = section.querySelector('#sl-click-rate-val');
    var valConvRate    = section.querySelector('#sl-conv-rate-val');

    /* Results */
    var elGapNumber    = section.querySelector('#sl-gap-number');
    var elCtaBlock     = section.querySelector('#sl-cta-block');
    var currencyEls    = section.querySelectorAll('.sl-roi__currency-prefix');

    /* Current scenario */
    var elCurMonthly   = section.querySelector('#sl-cur-monthly');
    var elCurPct       = section.querySelector('#sl-cur-pct');
    var elCurAnnual    = section.querySelector('#sl-cur-annual');
    var elCurCamp      = section.querySelector('#sl-cur-camp');
    var elCurFlow      = section.querySelector('#sl-cur-flow');

    /* Realistic scenario */
    var elRealMonthly  = section.querySelector('#sl-real-monthly');
    var elRealPct      = section.querySelector('#sl-real-pct');
    var elRealAnnual   = section.querySelector('#sl-real-annual');
    var elRealDelta    = section.querySelector('#sl-real-delta');
    var elRealCamp     = section.querySelector('#sl-real-camp');
    var elRealFlow     = section.querySelector('#sl-real-flow');

    /* Best scenario */
    var elBestMonthly  = section.querySelector('#sl-best-monthly');
    var elBestPct      = section.querySelector('#sl-best-pct');
    var elBestAnnual   = section.querySelector('#sl-best-annual');
    var elBestDelta    = section.querySelector('#sl-best-delta');
    var elBestCamp     = section.querySelector('#sl-best-camp');
    var elBestFlow     = section.querySelector('#sl-best-flow');

    /* Bar chart */
    var barCurCamp     = section.querySelector('#sl-bar-cur-camp');
    var barCurFlow     = section.querySelector('#sl-bar-cur-flow');
    var barRealCamp    = section.querySelector('#sl-bar-real-camp');
    var barRealFlow    = section.querySelector('#sl-bar-real-flow');
    var barBestCamp    = section.querySelector('#sl-bar-best-camp');
    var barBestFlow    = section.querySelector('#sl-bar-best-flow');
    var barCurLabel    = section.querySelector('#sl-bar-cur-label');
    var barRealLabel   = section.querySelector('#sl-bar-real-label');
    var barBestLabel   = section.querySelector('#sl-bar-best-label');

    /* Touched flags: prevent overwriting user-set slider values on vertical change */
    var touched = { openRate: false, clickRate: false, convRate: false };

    /* ── Apply vertical defaults ── */
    function applyVerticalDefaults(vertical) {
      var bench = BENCHMARKS[vertical];
      if (!bench) return;
      if (!touched.openRate) {
        slOpenRate.value = bench.defaultOR;
        updateSliderFill(slOpenRate);
        valOpenRate.textContent = bench.defaultOR + '%';
      }
      if (!touched.clickRate) {
        slClickRate.value = bench.defaultCTR;
        updateSliderFill(slClickRate);
        valClickRate.textContent = bench.defaultCTR.toFixed(1) + '%';
      }
      if (!touched.convRate) {
        slConvRate.value = bench.defaultConv;
        updateSliderFill(slConvRate);
        valConvRate.textContent = bench.defaultConv.toFixed(1) + '%';
      }
    }

    /* ── Update currency symbols ── */
    function updateCurrencySymbols(currency) {
      var sym = getSymbol(currency);
      for (var i = 0; i < currencyEls.length; i++) {
        currencyEls[i].textContent = sym;
      }
    }

    /* ── Core calculation ── */
    function calculate() {
      var vertical            = selVertical.value;
      var currency            = selCurrency.value;
      var monthlyStoreRevenue = parseFloat(inpRevenue.value)  || 0;
      var listSize            = parseFloat(inpListSize.value)  || 0;
      var activePct           = parseFloat(slActivePct.value)  || 0;
      var campaignsPerMonth   = parseFloat(slCampaigns.value)  || 0;
      var openRate            = parseFloat(slOpenRate.value)   || 0;
      var clickRate           = parseFloat(slClickRate.value)  || 0;
      var convRate            = parseFloat(slConvRate.value)   || 0;
      var aov                 = parseFloat(inpAov.value)       || 0;
      var flowRevenue         = parseFloat(inpFlow.value)      || 0;

      /* Active subs */
      var activeSubs = listSize * (activePct / 100);

      /* Campaign revenue — current */
      var emailsSent       = activeSubs * campaignsPerMonth;
      var clicks           = emailsSent * (clickRate / 100);
      var conversions      = clicks * (convRate / 100);
      var campaignRevenue  = conversions * aov;

      /* Current totals */
      var currentMonthly   = campaignRevenue + flowRevenue;
      var currentEmailPct  = monthlyStoreRevenue > 0
        ? (currentMonthly / monthlyStoreRevenue) * 100
        : 0;

      /* Benchmarks */
      var bench = BENCHMARKS[vertical] || BENCHMARKS.other;

      /* Realistic */
      var realEmailPct     = bench.realistic.emailPct;
      var realMonthly      = monthlyStoreRevenue * (realEmailPct / 100);
      var realFlowShare    = bench.realistic.flowShare;
      var realFlowRevenue  = realMonthly * (realFlowShare / 100);
      var realCampRevenue  = realMonthly - realFlowRevenue;

      /* Best */
      var bestEmailPct     = bench.best.emailPct;
      var bestMonthly      = monthlyStoreRevenue * (bestEmailPct / 100);
      var bestFlowShare    = bench.best.flowShare;
      var bestFlowRevenue  = bestMonthly * (bestFlowShare / 100);
      var bestCampRevenue  = bestMonthly - bestFlowRevenue;

      /* Gap */
      var monthlyGap       = Math.max(0, realMonthly - currentMonthly);
      var annualGap        = monthlyGap * 12;

      /* ── Update gap card ── */
      animateGap(annualGap, currency, elGapNumber);

      /* ── Update scenario cards ── */
      function delta(monthly) {
        var d = (monthly - currentMonthly) * 12;
        return (d >= 0 ? '+' : '') + formatMoney(d, currency) + ' vs. now';
      }

      elCurMonthly.textContent  = formatMoney(currentMonthly, currency) + '/mo';
      elCurPct.textContent      = currentEmailPct.toFixed(1) + '% of store revenue';
      elCurAnnual.textContent   = formatMoney(currentMonthly * 12, currency) + '/year';
      elCurCamp.textContent     = formatMoney(campaignRevenue, currency) + ' campaigns';
      elCurFlow.textContent     = formatMoney(flowRevenue, currency) + ' flows';

      elRealMonthly.textContent = formatMoney(realMonthly, currency) + '/mo';
      elRealPct.textContent     = realEmailPct.toFixed(1) + '% of store revenue';
      elRealAnnual.textContent  = formatMoney(realMonthly * 12, currency) + '/year';
      elRealDelta.textContent   = delta(realMonthly);
      elRealCamp.textContent    = formatMoney(realCampRevenue, currency) + ' campaigns';
      elRealFlow.textContent    = formatMoney(realFlowRevenue, currency) + ' flows';

      elBestMonthly.textContent = formatMoney(bestMonthly, currency) + '/mo';
      elBestPct.textContent     = bestEmailPct.toFixed(1) + '% of store revenue';
      elBestAnnual.textContent  = formatMoney(bestMonthly * 12, currency) + '/year';
      elBestDelta.textContent   = delta(bestMonthly);
      elBestCamp.textContent    = formatMoney(bestCampRevenue, currency) + ' campaigns';
      elBestFlow.textContent    = formatMoney(bestFlowRevenue, currency) + ' flows';

      /* ── Bar chart ── */
      var maxRev = Math.max(bestMonthly, 1);
      function barPct(v) { return (Math.min(v / maxRev, 1) * 100).toFixed(1) + '%'; }

      barCurCamp.style.width   = barPct(campaignRevenue);
      barCurFlow.style.width   = barPct(flowRevenue);
      barRealCamp.style.width  = barPct(realCampRevenue);
      barRealFlow.style.width  = barPct(realFlowRevenue);
      barBestCamp.style.width  = barPct(bestCampRevenue);
      barBestFlow.style.width  = barPct(bestFlowRevenue);

      barCurLabel.textContent  = formatMoney(currentMonthly, currency) + '/mo';
      barRealLabel.textContent = formatMoney(realMonthly, currency) + '/mo';
      barBestLabel.textContent = formatMoney(bestMonthly, currency) + '/mo';

      /* ── CTA ── */
      var ctaUrl, ctaLabel, ctaClass;
      if (annualGap >= qualThreshold) {
        ctaUrl   = typeformUrl ? buildTypeformUrl(typeformUrl, vertical, currency, {
          monthlyStoreRevenue: monthlyStoreRevenue,
          listSize: listSize, activePct: activePct,
          campaignsPerMonth: campaignsPerMonth,
          openRate: openRate, clickRate: clickRate, convRate: convRate,
          aov: aov, flowRevenue: flowRevenue,
          currentEmailPct: currentEmailPct,
          annualGap: annualGap,
          realisticAnnualRevenue: realMonthly * 12
        }) : '#';
        ctaLabel = 'Book your free audit';
        ctaClass = 'sl-roi__cta-btn';
      } else {
        ctaUrl   = newsletterUrl;
        ctaLabel = 'Get the DTC Retention Playbook';
        ctaClass = 'sl-roi__cta-btn sl-roi__cta-btn--secondary';
      }
      elCtaBlock.innerHTML = '<a href="' + ctaUrl + '" class="' + ctaClass + '" target="_blank" rel="noopener noreferrer">' + ctaLabel + '</a>';
    }

    var debouncedCalc = debounce(calculate, 50);

    /* ── Slider binding helper ── */
    function bindSlider(slider, valEl, suffix, touchKey, decimals) {
      function refresh() {
        var v = parseFloat(slider.value);
        valEl.textContent = (decimals ? v.toFixed(decimals) : Math.round(v)) + suffix;
        updateSliderFill(slider);
      }
      slider.addEventListener('input', function () {
        if (touchKey) touched[touchKey] = true;
        refresh();
        debouncedCalc();
      });
      refresh();
    }

    bindSlider(slActivePct,  valActivePct,  '%',  null,        0);
    bindSlider(slCampaigns,  valCampaigns,  '',   null,        0);
    bindSlider(slOpenRate,   valOpenRate,   '%',  'openRate',  1);
    bindSlider(slClickRate,  valClickRate,  '%',  'clickRate', 1);
    bindSlider(slConvRate,   valConvRate,   '%',  'convRate',  1);

    selVertical.addEventListener('change', function () {
      applyVerticalDefaults(this.value);
      calculate();
    });

    selCurrency.addEventListener('change', function () {
      updateCurrencySymbols(this.value);
      calculate();
    });

    [inpRevenue, inpListSize, inpAov, inpFlow].forEach(function (el) {
      el.addEventListener('input', debouncedCalc);
    });

    /* ── Bootstrap ── */
    var defaultVertical = config.defaultVertical || selVertical.value;
    var defaultCurrency = config.defaultCurrency || selCurrency.value;
    selVertical.value   = defaultVertical;
    selCurrency.value   = defaultCurrency;
    updateCurrencySymbols(defaultCurrency);
    applyVerticalDefaults(defaultVertical);
    calculate();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.sl-roi');
    if (section) init(section);
  });

})();
